"use client";
import axios from "axios";

import { useRouter } from "next/router";
import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Button } from "@material-tailwind/react";
import Link from "next/link";
import Head from "next/head";
import GenericHead from "@/src/components/Head/GenericHead";
import { sendAnalyticsEvent } from "@/src/utils/analytics";
// import { sendCaptchaVerification } from "@/src/utils/helpers";

const Register = () => {
  const router = useRouter();
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [isVerified, setIsverified] = useState<boolean>(true);

  async function handleCaptchaSubmission(token: string | null) {
    setIsverified(true);
    // return
    // await sendCaptchaVerification(token || "")
    //   .then((resp) => {
    //     if (resp) {
    //       setIsverified(true);
    //       setIsverified(resp);
    //     } else {
    //       setIsverified(false);
    //     }
    //   })
    //   .catch((e) => {
    //     setIsverified(false);
    //   });
  }

  const [loginFields, setLoginFields] = useState({
    email: "",
    username: "",
    password: "",
  });

  const [errorMessage, setErrorMessage] = useState<null | string>(null);
  const [errorType, setErrorType] = useState<null | string>(null);
  const [loading, setLoading] = useState(false);

  const onFormSubmit = async (event: any) => {
    sendAnalyticsEvent({
      type: "register",
      value: `register fired - ${email}`,
    });
    event.preventDefault();
    setLoading(true);
    //@ts-ignore
    const wpAccount = await axios.post("/api/auth/register", {
      username,
      email,
      password,
    });

    setLoading(false);
    console.log("WP ACCOUNT: ", wpAccount);
    if (!wpAccount.data.data) {
      if (
        wpAccount.data?.errors?.message?.includes(
          "username is already registered"
        )
      ) {
        setErrorMessage("Username already registered - try logging in");
        setErrorType("Login");
      } else if (
        wpAccount.data?.errors?.message?.includes(
          "email address is already registered"
        )
      ) {
        setErrorMessage("Email is already registered - try logging in");
        setErrorType("Login");
      } else {
        setErrorMessage(wpAccount.data?.errors?.message);
      }
    } else {
      // Successfull - need to then login and redirect?
      const loginReq = await axios
        .post("/api/login", { username, password })
        .catch((e) => e);
      if (loginReq.data?.success) {
        router.push("/account/myaccount");
      }
    }
  };

  const handleOnChange = (event: any) => {
    setLoginFields({ ...loginFields, [event.target.name]: event.target.value });
  };
  const { email, username, password } = loginFields;

  return (
    <>
      <GenericHead />

      <div className="login-form rounded-xl md:ml-auto  md:mt-12 md:w-5/12 px-4 md:px-0 m-auto my-6">
        <div
          className={
            "flex bg-scpb-dark-blue p-2 rounded-t-lg text-white items-center align-center w-full justify-center"
          }
        >
          <h4 className="text-white text-3xl font-medium title-font block">
            Register
          </h4>
        </div>
        <div className="bg-gray-100 p-8 shadow-xl">
          <form onSubmit={onFormSubmit} className="mb-4 flex flex-col">
            <div className="flex flex-col gap-2">
              <label className="leading-7 flex flex-col gap-2 text-sm text-gray-600">
                Email:
                <input
                  type="email"
                  className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  name="email"
                  value={email}
                  onChange={handleOnChange}
                />
              </label>
              <label className="leading-7 text-sm text-gray-600">
                Username:
                <input
                  type="text"
                  className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  name="username"
                  value={username}
                  onChange={handleOnChange}
                />
              </label>

              <label className="leading-7 text-sm text-gray-600">
                Password:
                <input
                  type="password"
                  className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  name="password"
                  value={password}
                  onChange={handleOnChange}
                />
              </label>
            </div>
            <div className={"py-4"}>
              {/* <ReCAPTCHA
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || ""}
                ref={recaptchaRef}
                onChange={handleCaptchaSubmission}
              /> */}
            </div>
            <Button
              className="text-white bg-scpb-light-blue border-0 py-2 px-8 focus:outline-none hover:bg-scpb-dark-blue rounded text-lg"
              type="submit"
              disabled={!isVerified}
            >
              Register
            </Button>
            {loading ? (
              <p>Loading...</p>
            ) : (
              errorMessage && (
                <div dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
              )
            )}
          </form>
          <Link as="p" href="/login" className="cursor-pointer">
            Already have an account? <span className="underline">Login</span>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Register;
